

//source: https://blog.abelotech.com/posts/number-currency-formatting-javascript/
export function FormatNumberWithCommas(value: string): string {
    return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function Round_Number(data: number, digits: number): any {
    return (<number>data).toFixed(digits);
}

export function Round_1Digit(data: number): any {
    return (<number>data).toFixed(1);
}

export function Round_2Digits(data: number): any {
    return (<number>data).toFixed(2);
}

export function ComputePercent(count: number, total: number): number {
    if (total == undefined || total == 0) return -1;
    else {
        let percent: number = (count / total) * 100.0;
        return percent;
    }
}

export function PadNumber(value: string, targetLength: number): string {
    if (value.length == 0) return "";
    else return value.length < targetLength ? PadNumber("0" + value, targetLength) : value;
}
